import React, { CSSProperties, FC } from 'react';
import Colors from '../../utils/colors';
import styles from './index.module.css';
export type Color = keyof typeof colors;

interface Props {
    color?: Color;
    icon?: React.ReactNode;
    raised?: boolean;
    onClickbutton?: () => void;
    onRefreshbutton?: () => void;
    rounded?: boolean;
    uppercase?: boolean;
    textColor?: Color;
    title?: string;
    fontSize?: string;
    fromChatInfo?: boolean;
    style?: CSSProperties;
    className?: any;
    full?: boolean;
    disabled?: boolean;
}

const colors = {
    primary: Colors.Blue,
    secondary: Colors.BaliHai,
    danger: Colors.RedDamask,
    accent: Colors.CuriousBlue,
    light: Colors.White,
    dark: Colors.Black,
    gray: Colors.GrayChateau,
    lightGreen: Colors.LightGreen,
};

const ButtonView: FC<Props> = ({
    title,
    color = 'primary',
    raised,
    rounded,
    onClickbutton,
    textColor,
    uppercase,
    icon,
    fontSize = 'regular',
    fromChatInfo,
    full,
    style = {},
    className,
    disabled = false,
    ...props
}) => {
    return (
        <div className={styles.container}>
            <div className={full ? styles.full : styles.buttonBox}>
                <button
                    disabled={disabled}
                    onClick={onClickbutton}
                    style={{
                        background: colors[color],
                        ...style,
                    }}
                    className={`${className} ${rounded ? styles.rounded : styles.notRounded}`}
                >
                    {title ? (
                        <p
                            style={{ fontSize: fontSize && fontSize }}
                            className={uppercase ? styles.uppercase : styles.notuppercase}
                        >
                            {title}
                        </p>
                    ) : null}
                    {icon ? icon : null}
                </button>
            </div>
        </div>
    );
};

export default ButtonView;
